import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.login');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-page-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.login/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 32px 16px;
  background: var(--design-bg);
  color: var(--design-text);
  font-family: SUIT, Arial, sans-serif;
}

.auth-panel {
  width: min(420px, 100%);
  border: 1px solid var(--design-border);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  padding: 28px;
  box-shadow: var(--design-shadow-strong);
}

.auth-back,
.auth-links a {
  color: var(--design-source);
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.auth-heading {
  margin: 22px 0 20px;
}

.auth-heading p {
  margin: 0 0 8px;
  color: var(--design-text-secondary);
  font-size: 13px;
  font-weight: 700;
}

.auth-heading h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 800;
}

.auth-notice {
  margin: 0 0 18px;
  border: 1px solid var(--design-border);
  border-radius: 8px;
  padding: 12px 13px;
  background: var(--design-card-tinted);
  color: var(--design-text);
}

.auth-notice strong {
  display: block;
  margin-bottom: 4px;
  color: var(--design-accent);
  font-size: 13px;
  font-weight: 800;
}

.auth-notice span {
  display: block;
  font-size: 13px;
  line-height: 1.55;
}

.auth-form {
  display: grid;
  gap: 14px;
}

.form-field {
  display: grid;
  gap: 7px;
  font-size: 13px;
  font-weight: 700;
}

.form-field small {
  color: var(--design-text-muted);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
}

.form-field em {
  color: #b42318;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.auth-form input {
  width: 100%;
  border: 1px solid var(--design-border-soft);
  border-radius: 8px;
  padding: 12px 13px;
  font-size: 14px;
  outline: none;
}

.auth-form input:focus {
  border-color: var(--design-accent);
  box-shadow: var(--design-focus-ring);
}

.form-field.is-invalid input {
  border-color: #d92d20;
  background: #fffafa;
}

.auth-error {
  margin: 0;
  border: 1px solid #f3b7b1;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff4f2;
  color: #b42318;
  font-size: 13px;
  font-weight: 700;
}

.auth-submit {
  border: 1px solid var(--design-accent);
  border-radius: 8px;
  padding: 12px 14px;
  background: var(--design-accent);
  color: var(--design-on-accent);
  font-size: 14px;
  font-weight: 800;
}

.auth-submit:disabled {
  opacity: 0.55;
}

.auth-links {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

/* Review 122: align auth screens with the clean neutral CTA system. */
.auth-page {
  background: #FFFFFF;
  color: var(--design-body-text, #2B2B2B);
}

.auth-panel {
  border-color: #E5E5E5;
  background: #FFFFFF;
  box-shadow: 0 8px 22px rgba(30, 30, 30, 0.04);
}

.auth-back,
.auth-links a {
  color: #536C7A;
}

.auth-back:hover,
.auth-back:focus-visible,
.auth-links a:hover,
.auth-links a:focus-visible {
  color: #1F1F1F;
  outline: none;
}

.auth-notice {
  border-color: #E5E5E5;
  background: #FAFAFA;
}

.auth-form input {
  border-color: #E5E5E5;
  background: #FFFFFF;
  color: #2B2B2B;
}

.auth-form input:focus {
  border-color: rgba(30, 30, 30, 0.22);
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.auth-submit {
  border-color: #1F1F1F;
  background: #1F1F1F;
  color: #FFFFFF;
  box-shadow: none;
}

.auth-submit:not(:disabled):hover,
.auth-submit:not(:disabled):focus-visible {
  border-color: #111111;
  background: #111111;
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.auth-submit:disabled {
  border-color: #E5E5E5;
  background: #F5F5F5;
  color: #666666;
  opacity: 1;
  cursor: not-allowed;
}

/* Review 124: login is a secondary CTA in the global button hierarchy. */
.auth-submit {
  border-color: #E5E5E5;
  background: #FFFFFF;
  color: #1F1F1F;
}

.auth-submit:not(:disabled):hover,
.auth-submit:not(:disabled):focus-visible {
  border-color: #E5E5E5;
  background: #F7F7F7;
  color: #1F1F1F;
  box-shadow: 0 0 0 3px rgba(31, 31, 31, 0.14);
}

.auth-submit:disabled {
  border-color: #E5E5E5;
  background: #F5F5F5;
  color: #A0A0A0;
}`],
})
export class PageLoginComponent implements OnInit {
    public username: string = '';
    public password: string = '';
    public loading: boolean = false;
    public errorMessage: string = '';
    public fieldErrors: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        let session = this.service.auth.session || {};
        if (this.service.auth.status && session.status === 'active') {
            this.service.href('/main');
            return;
        }
        if (this.service.auth.status && session.status !== 'active') {
            this.service.href('/pending');
            return;
        }
        await this.service.render();
    }

    public responseMessage(response: any, fallback: string = '요청을 처리하지 못했습니다.'): string {
        let data = response?.data;
        if (typeof data === 'string') return data;
        if (data?.message) return data.message;
        return fallback;
    }

    public async login() {
        this.errorMessage = '';
        this.fieldErrors = {};
        if (!this.username?.trim()) {
            this.fieldErrors.username = '아이디를 입력해주세요.';
        }
        if (!this.password) {
            this.fieldErrors.password = '비밀번호를 입력해주세요.';
        }
        if (Object.keys(this.fieldErrors).length > 0) {
            this.errorMessage = '아이디와 비밀번호를 모두 입력해주세요.';
            await this.service.render();
            return;
        }

        this.loading = true;
        await this.service.render();
        let response = await wiz.call('login', {
            username: this.username,
            password: this.password,
        });
        this.loading = false;

        if (response.code === 200 || response.code === 202) {
            window.location.href = response.data?.redirect || '/main';
            return;
        }

        this.errorMessage = this.responseMessage(response, '아이디 또는 비밀번호를 확인해주세요.');
        await this.service.render();
    }
}

export default PageLoginComponent;